module.exports = __webpack_public_path__ + "static/img/specialproduct.08bc3c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specialproduct.png
// module id = QUVI
// module chunks = 1